import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
export default function Login() {
    const { t } = useTranslation();
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const onSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setBusy(true);
        try {
            await login(email, password);
            nav('/dashboard');
        }
        catch {
            setError(t('common.error'));
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs("section", { className: "card form-card", children: [_jsx("h1", { children: t('login.title') }), _jsxs("form", { onSubmit: onSubmit, children: [_jsxs("label", { children: [t('common.email'), _jsx("input", { type: "email", required: true, value: email, onChange: (e) => setEmail(e.target.value) })] }), _jsxs("label", { children: [t('common.password'), _jsx("input", { type: "password", required: true, value: password, onChange: (e) => setPassword(e.target.value) })] }), error && _jsx("p", { className: "error", children: error }), _jsx("button", { type: "submit", className: "btn btn-primary", disabled: busy, children: busy ? t('common.loading') : t('login.submit') })] }), _jsx("p", { children: _jsx(Link, { to: "/register", children: t('login.noAccount') }) })] }));
}
